var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 70.36 39.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:#fff;stroke:#ccc;stroke-miterlimit:10;}.cls-4{fill:#231f20;}.cls-12,.cls-4,.cls-5,.cls-6,.cls-9{fill-rule:evenodd;}.cls-6{fill:#252122;}.cls-7{fill:url(#linear-gradient);}.cls-8{clip-path:url(#clip-path);}.cls-9{fill:url(#linear-gradient-2);}.cls-10{mask:url(#mask);}.cls-11{opacity:0.75;mix-blend-mode:multiply;}.cls-12{fill:#8b371e;}.cls-13{filter:url(#luminosity-invert);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 34.47,
    y1: 16.22,
    x2: 37.62,
    y2: 22.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#e35e26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a121"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 36.05,
    cy: 19.59,
    rx: 3.72,
    ry: 3.73
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 377.46,
    y1: 899.72,
    x2: 381.69,
    y2: 908.81,
    gradientTransform: "matrix(0.71, -0.63, 0.66, 0.75, -832.71, -417.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#e35e26",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a121",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-invert",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 30.03,
    y: 13.6,
    width: 13.68,
    height: 13.92,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("image", {
    width: 57,
    height: 58,
    transform: "translate(30.03 13.6) scale(0.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAA6CAYAAAAKjPErAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAXUlEQVRoQ+3PMRHAMADEsG/4c04hZNdZsxd/2+5w5xUImlQ0qWhS0aSiSUWTiiYVTSqaVDSpaFLRpKJJRZOKJhVNKppUNKloUtGkoklFk4omFU0qmlQ0qWhS0aTiB6LpAXPUbXoQAAAAAElFTkSuQmCC"
  }))))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0.5,
    y: 0.5,
    width: 69.36,
    height: 38.19,
    rx: 2.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12.89,16.23c0-.12,0-.16.15-.16.67,0,1.34,0,2,0a3.84,3.84,0,0,1,2.61,1,3.12,3.12,0,0,1,.94,1.74,3.47,3.47,0,0,1-1.17,3.43,3.27,3.27,0,0,1-2,.81c-.82.07-1.65,0-2.47,0-.1,0-.09-.05-.09-.11C12.89,22.31,12.9,17.35,12.89,16.23Zm1.37,5.56c0,.09,0,.12.12.12a7.4,7.4,0,0,0,.82,0,2.11,2.11,0,0,0,1.33-.56,2.3,2.3,0,0,0,.67-2.2,2.12,2.12,0,0,0-1.51-1.72,4.49,4.49,0,0,0-1.27-.12c-.12,0-.16,0-.16.16C14.27,18.16,14.27,21.06,14.26,21.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.47,20.16c.73,1,1.46,2,2.2,2.95H55.13a.24.24,0,0,1-.25-.14c-.58-.86-1.15-1.72-1.73-2.57,0,0,0,0,0,0s-.11-.08-.18-.07,0,.09,0,.13V23c0,.14,0,.17-.17.16H51.65c-.09,0-.13,0-.13-.12q0-3.39,0-6.8c0-.08,0-.12.1-.11.78,0,1.56,0,2.34,0a2.43,2.43,0,0,1,1.47.56,2,2,0,0,1,.61,1.67,1.81,1.81,0,0,1-1.48,1.79Zm-1.56-1.9v.93c0,.11,0,.13.13.13s.41,0,.61,0a1,1,0,0,0,1-1,.91.91,0,0,0-.67-1,3.17,3.17,0,0,0-.92-.1c-.1,0-.14,0-.13.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.74,16.21c0-.1,0-.14.14-.14h3.63c.09,0,.12,0,.12.13v1c0,.1,0,.11-.12.11H48.27c-.13,0-.16,0-.16.15,0,.43,0,.85,0,1.27,0,.11,0,.14.13.13.72,0,1.44,0,2.16,0,.12,0,.14,0,.13.14v.93c0,.1,0,.13-.12.13H48.27c-.13,0-.16,0-.15.16v1.59c0,.11,0,.14.13.14H50.5c.11,0,.14,0,.13.14v1c0,.08,0,.1-.1.1H46.85c-.12,0-.11-.05-.11-.12C46.74,21.85,46.75,17.34,46.74,16.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.07,21.08a1.66,1.66,0,0,0,.79.78,1.41,1.41,0,0,0,1.19.05.9.9,0,0,0,.57-.85.83.83,0,0,0-.53-.82c-.39-.19-.81-.31-1.21-.48a2.47,2.47,0,0,1-1-.72,1.35,1.35,0,0,1-.29-.71A2,2,0,0,1,23,16.08a2.88,2.88,0,0,1,2.71.6c.06.05.08.08,0,.15-.21.26-.41.52-.61.79-.06.08-.08.05-.13,0a1.33,1.33,0,0,0-.8-.47,1.12,1.12,0,0,0-1.1.33.6.6,0,0,0,.13.92,4.18,4.18,0,0,0,1,.44,7.91,7.91,0,0,1,.89.41A1.75,1.75,0,0,1,26,20.76a2.21,2.21,0,0,1-1.66,2.41A2.79,2.79,0,0,1,21.22,22c0-.05,0-.07,0-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.37,16.08h1.39a.15.15,0,0,1,.16.12l1.82,4.57c.08-.09,1.29-3.16,1.86-4.58,0-.06,0-.11.12-.1h1.41c-.11.26-2.1,5-3,7.1a.16.16,0,0,1-.17.11h-.53a.14.14,0,0,1-.14-.1c-.55-1.32-2.46-6-2.87-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.89,18a3,3,0,0,0-.8-.6,2.24,2.24,0,0,0-3,1.28,2.47,2.47,0,0,0,.47,2.64,2.2,2.2,0,0,0,1.77.7,2.08,2.08,0,0,0,1.39-.58,1.29,1.29,0,0,0,.17-.16c.05,0,0,.07,0,.11v1.38a.14.14,0,0,1-.08.15,3.79,3.79,0,0,1-4.3-.72,3.57,3.57,0,0,1-1-2.52,3.64,3.64,0,0,1,2.6-3.56,3.58,3.58,0,0,1,2.74.21c.05,0,.08.05.08.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M20.68,23c0,.11,0,.16-.15.15H19.41c-.09,0-.12,0-.12-.11q0-3.41,0-6.8c0-.11,0-.13.13-.13h1.1c.12,0,.16,0,.16.16C20.67,17.35,20.67,21.84,20.68,23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M56.68,16.23v.69A.43.43,0,0,1,56.68,16.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M14.26,17.44c0-.14,0-.16.16-.16a4.49,4.49,0,0,1,1.27.12,2.12,2.12,0,0,1,1.51,1.72,2.3,2.3,0,0,1-.67,2.2,2.11,2.11,0,0,1-1.33.56,7.4,7.4,0,0,1-.82,0c-.1,0-.12,0-.12-.12C14.27,21.06,14.27,18.16,14.26,17.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M52.91,18.26v-.94c0-.11,0-.13.13-.13a3.17,3.17,0,0,1,.92.1.91.91,0,0,1,.67,1,1,1,0,0,1-1,1c-.2,0-.41,0-.61,0s-.14,0-.13-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M56.93,16a.54.54,0,1,0,.54.54A.54.54,0,0,0,56.93,16Zm0,1a.43.43,0,0,1-.42-.44.43.43,0,1,1,.85,0A.43.43,0,0,1,56.93,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M57,16.63l.2.26H57s0,0,0,0l-.16-.23h0s0,0,0,0v.23s0,0,0,0h-.1a0,0,0,0,1,0,0v-.61h.22a.24.24,0,0,1,.14,0,.2.2,0,0,1,0,.15.15.15,0,0,1-.13.16Zm-.14-.18v.09s0,0,0,0h0q.09,0,.09-.09a.07.07,0,0,0-.06-.09h-.08s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 36.05,
    cy: 19.59,
    rx: 3.72,
    ry: 3.73
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.19,17.57c1.86,2.1,1.88,5.12.06,6.73s-4.81,1.21-6.67-.89-1.89-5.12-.07-6.73S38.32,15.46,40.19,17.57Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M40.19,17.57c1.86,2.1,1.88,5.12.06,6.73s-4.81,1.21-6.67-.89-1.89-5.12-.07-6.73S38.32,15.46,40.19,17.57Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.d73b7be46ea83e5f9e4996e66ca15171.svg";
export { ForwardRef as ReactComponent };